module.exports = __webpack_public_path__ + "media/images/relogio-9873fe23d6ce579373b09dc7dd834f81.png";